'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var tslib = require('tslib');
var core = require('@material-ui/core');
var styles = require('@material-ui/core/styles');
var styledComponents = require('./styled-components.js');

var TextWithTooltip = function (props) {
    var icon = props.icon, displayText = props.displayText, tooltipText = props.tooltipText, tooltipStyles = props.tooltipStyles, _a = props.arrow, arrow = _a === void 0 ? true : _a, _b = props.placement, placement = _b === void 0 ? 'bottom-start' : _b, _c = props.ariaLabel, ariaLabel = _c === void 0 ? '' : _c;
    var styles$1 = {
        tooltip: tslib.__assign({ fontSize: '15px', fontFamily: 'TT Commons, Arial, sans-serif', border: '1px solid #FFFFFF', borderRadius: '3px', fontWeight: 400, backgroundColor: '#6d6d6d' }, tooltipStyles),
    };
    var useStyles = styles.makeStyles(function () { return styles.createStyles(styles$1); });
    var createdClasses = useStyles();
    var getAriaLabel = function () {
        return ariaLabel || (typeof displayText === 'string' ? displayText : '');
    };
    return (React__default.createElement(styledComponents, { title: React__default.createElement(React__default.Fragment, null,
            React__default.createElement("span", null, tooltipText)), "aria-label": getAriaLabel(), placement: placement, classes: { tooltip: createdClasses.tooltip }, interactive: true, arrow: arrow },
        React__default.createElement(core.Grid, { container: true, alignItems: 'center' },
            icon && (React__default.createElement(core.Grid, { item: true, "data-testid": 'display-icon' }, icon)),
            React__default.createElement(core.Grid, { item: true, xs: true },
                React__default.createElement("span", null, displayText)))));
};

module.exports = TextWithTooltip;
